import React, { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { useNotify, useUtilityBillById } from "hooks";
import { getFromLocalStorage, setToLocalStorage } from "utils";
import { BillModal, Drawer, Loading } from "components";

import { UTILITY_BILL_PAGE } from "../consts";
import "./css/style.css"

export const UtilityBill: React.FunctionComponent = () => {
  const notify = useNotify();
  const navigate = useNavigate();

  const { billId } = useParams<{ [UTILITY_BILL_PAGE.KEY]: string }>();

  const { data: utilityBill, isLoading, isError } = useUtilityBillById(billId || "");

  const [isOpen, setIsOpen] = useState(!!billId);
  const hasHandledError = useRef(false);

  const getType = getFromLocalStorage("type") || "";

  const onClose = useCallback(() => {
    let getURL: string = "";
    if (getType.includes("Upload")) {
      getURL = getFromLocalStorage("Upload_URL") || "";
    }
    if (getType.includes("Emissions")) {
      getURL = getFromLocalStorage("Emission_URL") || "";
    }
    if (getType.includes("Summary")) {
      getURL = getFromLocalStorage("Summary_URL") || "";
    }

    navigate(getURL);
    localStorage.removeItem("type");
    localStorage.removeItem("Upload_URL");

    setIsOpen((state) => !state);
  }, [navigate, getType]);

  useEffect(() => {
    if (utilityBill?.id) {
      setToLocalStorage("billEntriesIdSelected", utilityBill.id);
    }
  }, [utilityBill?.id]);

  useEffect(() => {
    if (hasHandledError.current) {
      return;
    }

    if (!billId || isError) {
      hasHandledError.current = true;
      notify.error("Invalid utility bill ID. Please try again.");
      onClose();
    }
  }, [billId, isError, notify, onClose]);

  return (
    <Drawer
      anchor="right"
      open={isOpen}
      onClose={onClose}
      zIndex={1300}
      customPaperProps={{ width: "100%", height: "auto", overflow: "hidden" }}
      expandedWidth='100%'
    >
      {(isLoading) ? (
        <Loading />
      ) : (
        utilityBill && (
          <BillModal
            document={utilityBill}
            isLoading={isLoading}
            onClose={onClose}
            billId={billId as string}
          />
        )
      )}
    </Drawer>
  );
};
